





































































































































































































































































































































































































































import jwt from 'jsonwebtoken';
import semver from 'semver';

import Wave from './components/Wave.vue';
// LEGACY-V2-BRIDGE — TEMPORARIO, se borra con la v2.
import { consolePathFor, getV3ConsoleUrl } from './v3Redirect';

export default {
	name: 'Auth',
	components: {
		Wave,
	},
	inject: ['responsive'],
	props: {
		fromWebsite: {
			type: Boolean,
			default: false,
		},
		showDashboard: {
			type: Boolean,
			default: false,
		},
		signMethod: {
			type: String,
			default: 'signin',
		},
	},
	data() {
		return {
			form: {
				email: '',
				password: '',
			},
			rules: {},
			loading: false,
			loadingText: this.$t('common.loading'),
			navigator: window.navigator,
			enterpriseDrawer: false,
			organizationData: {
				licensePerUser: true,
				name: 'Rambox',
				logo: './img/icon.png',
				providers: {
					emailPassword: true,
					google: true,
					facebook: true,
				},
			},
			providers: [],
			isFacebook: false,
			facebookError: {},
			facebookForm: {
				pass: '',
			},
			inputField: '',
			query: null,
			verifyMsg: null,
			minVersion: '1.0.0',
			ramboxOrgData: {
				name: 'Rambox',
				logo: './img/icon.png',
				licensePerUser: true,
				providers: {
					facebook: true,
					google: true,
				},
				whiteLabel: {
					sectionColor: '#07a6cb',
					primaryColor: '#0675a0',
					titlebar: '#0675a0',
				},
				tenantId: 'rambox-jk1w4',
			},
			notQuery: undefined,
			force: false, // To force the login even if the user is already logged in (used for Facebook if the user uncheck the "email" scope)
		};
	},
	computed: {
		ramboxUA(): boolean {
			return window.navigator.userAgent.includes('RamboxLogin');
		},
		isRamboxApp(): boolean {
			return this.ramboxUA && this.ramboxInterface('rambox-login');
		},
		showEnterprise(): boolean {
			return (
				this.signMethod === 'signin' &&
				this.$route.params.id === 'rambox' &&
				!this.isBilling &&
				!this.isPartners &&
				!this.fromWebsite
			);
		},
		isBilling(): boolean {
			return (
				this.query &&
				this.query.redirect_uri &&
				this.query.redirect_uri.indexOf(!this.$isDev ? 'billing.rambox.app' : 'localhost:3000') !== -1
			);
		},
		isPartners(): boolean {
			return (
				this.query &&
				this.query.redirect_uri &&
				this.query.redirect_uri.indexOf(!this.$isDev ? 'partners.rambox.app' : 'localhost:3001') !== -1
			);
		},
		currentVersion(): string {
			return (this.ramboxUA && navigator.userAgent.split('---')[1]) || this.minVersion;
		},
		olderVersion(): string {
			return semver.lte(this.currentVersion, '2.0.2');
		},
		notAllowedVersion(): boolean {
			return this.isRamboxApp && semver.gt(this.minVersion, this.currentVersion);
		},
		isFreshdesk(): boolean {
			return this.query && this.query.redirect_uri && this.query.redirect_uri.indexOf('freshworks') !== -1;
		},
		showDivider(): boolean {
			return (
				(this.organizationData.providers.emailPassword === undefined ||
					this.organizationData.providers.emailPassword) &&
				Object.keys(this.organizationData.providers).filter(
					k => k !== 'emailPassword' && this.organizationData.providers[k]
				).length !== 0
			);
		},
	},
	watch: {
		$route(to, from) {
			if (to.path === to.from) return;
			this.inputField = '';
			this.getOrganizationInfo();
		},
		'form.email'(newValue, oldValue) {
			if (newValue === oldValue) return;
			this.form.email = newValue.toLowerCase();
		},
	},
	methods: {
		ramboxInterface(
			type: 'send-action' | 'rambox-login' | 'white-label' | 'return-data',
			data?: unknown
		): void | boolean {
			const contextIsolated = semver.gte(this.currentVersion, '2.1.0-beta.1');
			// @ts-ignore-next-line
			const actions = contextIsolated ? window.login : global;
			switch (type) {
				case 'rambox-login':
					return actions.ramboxLogin();
				case 'send-action':
					// @ts-ignore-next-line
					actions.sendAction(...data);
					break;
				case 'white-label':
					actions.whiteLabel(data);
					break;
				case 'return-data':
					actions.returnData(data);
					break;
				default:
					break;
			}
		},
		openLink(url: string): void {
			window.open(url);
		},
		async getRemoteData(): Promise<void> {
			try {
				if (!this.isRamboxApp) return;
				await this.$remoteConfig.fetchAndActivate();
				const tmp = this.$remoteConfig.getValue('minVersion');
				this.minVersion = tmp.asString() || '1.0.0';
			} catch (error) {
				console.log('Error while getting Remote config data', error.message | error);
			}
		},
		async validateForm(id): Promise<boolean> {
			try {
				return await this.$refs[id].validate();
			} catch (error) {
				return false;
			}
		},
		enterpriseLogin(): void {
			if (this.inputField === '') return;
			this.enterpriseDrawer = false;
			this.$router.push(`/${this.inputField}`);
		},
		async sendVerificationEmail(notify = true): Promise<void> {
			try {
				const user = this.$firebase.auth().currentUser;
				if (!user) return;
				this.loadingText = this.$t('auth.loading.sendingVerificationEmail');
				await this.$firebase.functions().httpsCallable('sendVerificationEmail')({
					email: user.email,
					tenantId: await this.getTenantId(),
				});
				const h = this.$createElement;
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.verifyMsg =
					notify &&
					this.$NOTIFICATION_HANDLER('VERIFY_EMAIL', {
						message: h('p', null, [
							h(
								'span',
								null,
								`${this.$t('auth.verifyEmail.text', {
									email: user.email || this.$t('auth.verifyEmail.yourEmail'),
								})} `
							),
							h(
								'el-button',
								{
									style: {
										padding: 0,
										'font-size': 'inherit',
									},
									attrs: {
										type: 'text',
									},
									on: {
										click: () => {
											window.open('https://support.rambox.app/a/solutions/articles/42000099729');
										},
									},
								},
								this.$t('auth.verifyEmail.article')
							),
							h('span', null, `.`),
						]),
					});
			} catch (error) {
				console.error(error);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$NOTIFICATION_HANDLER(error);
				return;
			}
		},
		sendResetEmail() {
			this.$prompt(this.$t('auth.resetPrompt.message'), this.$t('auth.resetPrompt.title'), {
				confirmButtonText: this.$t('common.send'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning',
				inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
				inputErrorMessage: this.$t('auth.resetPrompt.invalidEmail'),
				roundButton: true,
				beforeClose: async (action, instance, done) => {
					if (action !== 'confirm') return done();
					instance.confirmButtonLoading = true;
					instance.confirmButtonText = this.$t('common.sending');
					try {
						await this.$firebase.functions().httpsCallable('sendResetPasswordEmail')({
							email: instance.inputValue,
							tenantId: await this.getTenantId(),
						});
						done();
						this.$message({
							type: 'success',
							message: this.$t('auth.resetPrompt.sent', { email: instance.inputValue }),
						});
					} catch (error) {
						console.error(error);
						done();
						this.$NOTIFICATION_HANDLER(error);
					} finally {
						instance.confirmButtonLoading = false;
						instance.confirmButtonText = this.$t('common.send');
					}
				},
			});
		},
		async userPassLogin(): Promise<void> {
			const valid = await this.validateForm('form');
			if (!valid) return;

			try {
				this.loading = true;
				this.verifyMsg && this.verifyMsg.close();
				this.verifyMsg = null;
				this.loadingText = this.$t('auth.loading.authenticating');
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password);
				if (result.user && !result.user.emailVerified) return this.sendVerificationEmail(); // only for desktop?
				return this.finalStep(result.user);
			} catch (error) {
				console.error(error);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$NOTIFICATION_HANDLER(error);
			}
		},
		async userPassSignUp(): Promise<void> {
			const valid = await this.validateForm('form');
			if (!valid) return;

			try {
				this.loading = true;
				this.loadingText = this.$t('auth.loading.settingUpUser');
				this.$firebase.auth().tenantId = await this.getTenantId();
				await this.$firebase.auth().createUserWithEmailAndPassword(this.form.email, this.form.password);
				await this.sendVerificationEmail(!this.fromWebsite);
				// We send the email to the website for the affiliation program
				if (this.fromWebsite) {
					this.loading = true;
					const clientId = await this.getGaClientId();
					if (clientId) {
						try {
							await this.$firebase.functions().httpsCallable('signedUp')({
								clientId,
								tenantId: this.organizationData.tenantId,
							});
						} catch (e) {
							console.error('signedUp error', e);
						}
					}
					window.location.href = `${this.query.redirect_uri}?email=${this.form.email}&validate=true`;
				} else {
					this.signMethod = 'signin';
					this.loading = false;
				}
			} catch (error) {
				console.error(error);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
				this.$NOTIFICATION_HANDLER(error);
			}
		},
		async samlLogin(): Promise<void> {
			let provider = new this.$firebase.auth.SAMLAuthProvider('saml.jumpcloud');
			try {
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithRedirect(provider);
				return console.log('result', result);
			} catch (error) {
				console.error(error);
				return;
			}
		},
		async microsoftLogin(): Promise<void> {
			let provider = new this.$firebase.auth.OAuthProvider('microsoft.com');
			provider.setCustomParameters({
				prompt: 'consent',
				tenant: this.organizationData.providers.microsoft,
			});
			try {
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithRedirect(provider);
				return console.log('result', result);
			} catch (error) {
				console.error(error);
				return;
			}
		},
		async facebookLogin(): Promise<void> {
			let provider = new this.$firebase.auth.FacebookAuthProvider();
			this.force &&
				provider.setCustomParameters({
					auth_type: 'rerequest',
				});
			try {
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithRedirect(provider);
				return console.log('result', result);
			} catch (error) {
				console.error(error);
				return;
			}
		},
		async googleLogin(email): Promise<void> {
			let provider = new this.$firebase.auth.GoogleAuthProvider();
			let customParameters: { prompt: string; display: string; login_hint?: string } = {
				prompt: 'select_account',
				display: 'popup',
			};
			if (email) customParameters = { ...customParameters, login_hint: email };
			provider.setCustomParameters(customParameters);
			try {
				this.$firebase.auth().tenantId = await this.getTenantId();
				const result = await this.$firebase.auth().signInWithRedirect(provider);
				return console.log('result', result);
			} catch (error) {
				console.error(error);
				return;
			}
		},
		async freshdeskAuth(user): Promise<void | string> {
			const getQuery = async () => {
				this.loading = true;
				const organization = this.showDashboard ? 'rambox' : this.$route.params.id;
				if (!organization) throw new Error(this.$t('auth.errors.organizationNotFound'));

				organization !== 'rambox' && (await this.getOrganizationInfo());

				const obj = {
					uid: user.uid,
					email: user.email.toLowerCase(),
					name: user.displayName || user.email.substring(0, user.email.indexOf('@')),
					path: `organizations/${organization}/users/${user.email}`,
					tenantId: user.tenantId,
					organization,
				};
				this.organizationData.freshdeskId && Object.assign(obj, { companyId: this.organizationData.freshdeskId });

				localStorage.setItem('userFreshdesk', JSON.stringify(obj));

				window.location.href =
					'https://rambox.freshworks.com/login/auth/1611610668490?client_id=451979510707337272&redirect_uri=https://rambox.freshdesk.com/freshid/customer_authorize_callback?hd=support.rambox.app';
			};
			try {
				if (!user) throw new Error(this.$t('auth.errors.freshdesk'));
				if (!this.query) return getQuery();

				const organization = this.showDashboard ? 'rambox' : this.$route.params.id;
				if (!organization) throw new Error(this.$t('auth.errors.organizationNotFound'));
				const callableData = user.path
					? { ...user, nonce: this.query.nonce }
					: {
							uid: user.uid,
							email: user.email.toLowerCase(),
							name: user.displayName || user.email.substring(0, user.email.indexOf('@')),
							path: `organizations/${organization}/users/${user.email}`,
							tenantId: user.tenantId,
							organization,
							nonce: this.query.nonce,
					  };
				this.organizationData.freshdeskId &&
					Object.assign(callableData, { companyId: this.organizationData.freshdeskId });

				const data = await this.$firebase.functions().httpsCallable('freshdeskAuth')(callableData);
				const privateKey = [
					'-----BEGIN RSA PRIVATE KEY-----',
					'MIICXAIBAAKBgQDbstg7lc9YWpvUJp9sWHimeRKz9HDYM6qtZo2JKOjAlpc+7iX9',
					'qNmRo6YP9tpne9CMMv1vcUmvIBOrkAI6ZXDHZSaWgjpxsdbi1b4PcyZFL60F6QFR',
					'InuOU8A7GmunmzISUGooyo/swFA+/5R14foPBdpSjYp4ZTm9xY2CCyi2AQIDAQAB',
					'AoGAXEZjt7MWYV+9L4ABWbpXAmS7zEWQ193rg+Uc8UzzZWBaqh3QaxfuOdNoPjBK',
					'T0ibsScBdzs33Yw1dsuHhAtzMCUPZtdiG8a6cNZV3oa819Wps4HBbVNHnLYv/g8C',
					'1DeZ99wb2v3TP0BpY68pqZifxcY07OY5dETY+J/+Z++c8yECQQD3jM0EA6p58Mxs',
					'UnweCLTRv7CtjcHWvrOUwO3SJOC8f0wFybbeRsuwM2G4bCKZEBTHmqFL4dgNV71y',
					'EzX6zuNNAkEA4zKqkk/4oeIJYlhtb/sJMREXTBvd0iyR2iqLxWA2BegbhMsfhnt9',
					'Uze9yDIocepiDaORO/HtPD/Yn5myEcGbhQJAJ09Vkwid/qUtYRosGXzaceBVxwmW',
					'uWopDDsiyNcQVP6F7PleL6fgWoeeQfHyAIpcMmIssOcZLu066S2ByeUmlQJAFxab',
					'ButhlPHnijr6RBr6wCXAfFeIn0cwOz9/nLs+QjNoOIJ73arG/aH4g1O1kH4FIOWy',
					'aKkZNro2RWHVGsDWEQJBAO66znuuwLOynjguPG+SAA8+8d0kKyqvnHQrNNpYAWRa',
					'cQzQNKj7dr6HOSxrgct0Yz81TD1XgsCwi8R0NTOTI3g=',
					'-----END RSA PRIVATE KEY-----',
				].join('\n');

				const token = jwt.sign(data.data, privateKey, { algorithm: 'RS256' });
				localStorage.clear();

				window.location.href = `${this.query.redirect_uri}?state=${this.query.state}&id_token=${token}`;
				this.loading = false;
			} catch (error) {
				console.error(error);
				this.loading = false;
				this.$NOTIFICATION_HANDLER(error);
				await this.getOrganizationInfo();
			}
		},
		async desktopAuth(user): Promise<void> {
			const data = {
				path: `organizations/${this.$route.params.id}/users/${user.email}`,
				user_id: user.uid,
				email: user.email.toLowerCase(),
				picture:
					user.photoURL ||
					'https://firebasestorage.googleapis.com/v0/b/rambox-d1326.appspot.com/o/unknown_user_512.png?alt=media',
				name: user.displayName || user.email,
				version: this.navigator.userAgent.split('---')[1],
				user_metadata: {},
				organization: this.$route.params.id,
				emailVerified: user.emailVerified,
			};
			try {
				const response = await this.$firebase.functions().httpsCallable('ramboxLogin')(data);
				this.ramboxInterface('return-data', response.data);
			} catch (error) {
				this.loading = false;
				this.$NOTIFICATION_HANDLER(error, { type: 'error', duration: 6000 });
				await this.getOrganizationInfo();
			}
		},
		async getOrganizationInfo(): Promise<void> {
			try {
				if (this.fromWebsite || this.showDashboard || this.$route.params.id === 'rambox') {
					this.organizationData = this.ramboxOrgData;
					this.loading = false;
					if (this.isPartners) this.signMethod = 'signup';
					return;
				}
				this.loading = true;
				this.loadingText = this.$t('auth.loading.gettingOrganizationData');
				const response = await this.$firebase.functions().httpsCallable('getOrganizationInfo')(this.$route.params.id);
				this.organizationData = response.data;
				// @ts-ignore
				// this.isRamboxApp && this.ramboxInterface('white-label', response.data);
				this.loading = false;
				this.loadingText = this.$options.data.call(this).loadingText;
			} catch (error) {
				console.log(error);
				this.loading = false;
				this.$NOTIFICATION_HANDLER(error);
				this.organizationData = this.$options.data.call(this).organizationData;
				this.$router.push(`/rambox`);
			} finally {
				if (this.$refs.inputEmail) setTimeout(() => this.$refs.inputEmail.focus(), 500);
			}
		},
		async getTenantId(): Promise<String> {
			if (this.organizationData.tenantId) return this.organizationData.tenantId;
			try {
				await this.getOrganizationInfo();
				if (!this.organizationData.tenantId) throw new Error(this.$t('auth.errors.noTenantId'));
				return this.organizationData.tenantId;
			} catch (error) {
				console.log(error);
				this.loading = false;
				this.$NOTIFICATION_HANDLER(error);
				this.organizationData = this.$options.data.call(this).organizationData;
				this.$router.push(`/rambox`);
				return '';
			}
		},
		// TODO: The linker needs to be generic because for Microsoft we also need it.
		async facebookProviderLinker(password): Promise<any> {
			if (!password) {
				localStorage.setItem('token', this.facebookError.credential.accessToken);
				return this.googleLogin(this.facebookError.email);
			}
			try {
				const valid = await this.validateForm('facebookForm');
				if (!valid) return;

				this.loading = true;
				this.loadingText = this.$t('auth.loading.authenticating');
				this.$firebase.auth().tenantId = this.facebookError.tenantId;
				const result = await this.$firebase
					.auth()
					.signInWithEmailAndPassword(this.facebookError.email, this.facebookForm.pass);
				result.user.linkWithCredential(this.facebookError.credential);
				this.$message({
					type: 'success',
					message: this.$t('auth.facebook.linked', {
						provider: this.facebookError.credential.providerId,
						email: this.facebookError.email,
					}),
				});
				this.isRamboxApp ? await this.desktopAuth(result.user) : await this.freshdeskAuth(result.user);
			} catch (error) {
				console.log(error);
				this.loading = false;
				this.$NOTIFICATION_HANDLER(error);
			}
		},
		async getToken(user): Promise<string> {
			return await this.$firebase.functions().httpsCallable('getCustomToken')({
				displayName: user.displayName,
				photoURL: user.photoURL,
				uid: user.uid,
				email: user.email,
				organization: this.fromWebsite ? 'rambox' : this.$route.params.id,
			});
		},
		async goToBilling(user): Promise<void> {
			const baseURL = !this.$isDev ? 'https://billing.rambox.app' : 'http://localhost:3000';
			const token = await this.getToken(user);
			localStorage.clear();
			this.loading = false;
			this.loadingText = this.$options.data.call(this).loadingText;
			window.location.href = `${baseURL}?token=${token.data}`;
		},
		goToPartners(user): void {
			const params = {
				uid: user.uid,
				code: this.query.code,
				partner: this.query.partner,
				email: user.email,
			};
			const baseURL = !this.$isDev ? 'https://partners.rambox.app' : 'http://localhost:3001';
			window.location.href = `${baseURL}?${new URLSearchParams(params).toString()}`;
		},
		async finalStep(user) {
			if (this.isRamboxApp) return await this.desktopAuth(user);
			if (this.isFreshdesk) return await this.freshdeskAuth(user);
			// LEGACY-V2-BRIDGE — TEMPORARIO: una cuenta que ya es de Rambox 3 no sigue a billing, admin ni partners
			// v2: va a la consola, ya logueada. El desktop v2 y Freshdesk quedan afuera a propósito (arriba): el
			// desktop v2 ya rechaza cuentas v3 en su login (api_prod ramboxLogin) y el SSO de soporte no tiene par.
			const v3ConsoleUrl = await getV3ConsoleUrl(
				await user.getIdToken(),
				consolePathFor(this.query && this.query.redirect_uri)
			);
			if (v3ConsoleUrl) {
				localStorage.clear();
				window.location.href = v3ConsoleUrl;
				return;
			}
			if (this.isPartners) return this.goToPartners(user);
			this.sendToken(user);
		},
		// Function to get token to be used in Billing portal
		async sendToken(user): Promise<void> {
			const token = (this.fromWebsite || this.$route.params.id === 'rambox') && (await this.getToken(user));
			localStorage.clear();
			this.loadingText = this.$options.data.call(this).loadingText;
			if (!this.query) {
				this.loading = false;
				this.notQuery = user;
				return;
			}

			// We send the email to the website for the affiliation program
			const clientId = await this.getGaClientId();
			if (clientId) {
				try {
					await this.$firebase.functions().httpsCallable('signedUp')({
						clientId,
						tenantId: this.organizationData.tenantId,
					});
				} catch (e) {
					console.error('signedUp error', e);
				}
			}
			if (token) {
				window.location.href = this.fromWebsite
					? `${this.query.redirect_uri}?email=${user.email}`
					: `${this.query.redirect_uri}?token=${token.data}`;
			}
		},
		getGaClientIdFromCookie(): string | null {
			try {
				const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
				if (!match) return null;
				// Format: GA1.1.XXXXXXXXX.XXXXXXXXX — client_id is everything after the 2nd dot
				const parts = match[1].split('.');
				if (parts.length < 4) return null;
				return `${parts[2]}.${parts[3]}`;
			} catch (e) {
				return null;
			}
		},
		getGaClientId(): Promise<string | null> {
			return new Promise(resolve => {
				const fallback = () => resolve(this.getGaClientIdFromCookie());
				const timeout = setTimeout(fallback, 1500);
				try {
					if (typeof window.gtag !== 'function') {
						clearTimeout(timeout);
						return fallback();
					}
					window.gtag('get', process.env.VUE_APP_measurementId, 'client_id', (clientId: string) => {
						clearTimeout(timeout);
						resolve(clientId || this.getGaClientIdFromCookie());
					});
				} catch (e) {
					clearTimeout(timeout);
					fallback();
				}
			});
		},
		async getProviders(email: string, tenantId: string): Promise<string[]> {
			let arr: string[] = ['password'];
			try {
				const response = await this.$firebase.functions().httpsCallable('getUserProviders')({ email, tenantId });
				arr = response.data || ['password'];
				return arr;
			} catch (error) {
				console.error(error);
			}
			return arr;
		},
	},
	async mounted() {
		const userFreshdesh = localStorage.getItem('userFreshdesk');
		localStorage.clear();
		Object.keys(this.$route.query).length !== 0 && localStorage.setItem('query', JSON.stringify(this.$route.query));
		try {
			this.loading = true;
			await this.getRemoteData();
			if (this.notAllowedVersion) return (this.loading = false);
			const result = await this.$firebase.auth().getRedirectResult();
			const token = localStorage.getItem('token');
			// @ts-ignore-next-line
			this.query = JSON.parse(localStorage.getItem('query'));
			if (!this.isRamboxApp && this.query && userFreshdesh) return this.freshdeskAuth(JSON.parse(userFreshdesh));
			localStorage.removeItem('token');
			if (!result.user && !this.showDashboard) return await this.getOrganizationInfo();

			// If the user is new and signed up with a provider and the email was empty, we just show a message and stop the flow
			// because we can't link the account without knowing the email of the user.
			if (result.additionalUserInfo && result.additionalUserInfo.profile && !result.additionalUserInfo.profile.email) {
				this.loading = false;
				this.force = true; // We set force to true to force the re-authentication in case the user uncheck the email scope
				return this.$message({
					type: 'error',
					duration: 6000,
					message: this.$t('auth.errors.noEmailScope'),
				});
			}

			if (!!token && result.credential.providerId === 'facebook.com') {
				// TODO: Check if the credential stored in result.credential can be used to link the account
				const credential = this.$firebase.auth.FacebookAuthProvider.credential(token);
				await result.user.linkWithCredential(credential);
				this.$message({
					type: 'success',
					message: this.$t('auth.facebook.linked', {
						provider: result.credential.providerId,
						email: result.email,
					}),
				});
			}

			this.loadingText = this.$t('auth.loading.authenticating');
			await this.finalStep(result.user);
			this.loading = false;
			this.loadingText = this.$options.data.call(this).loadingText;
		} catch (error) {
			if (error.email && error.credential && error.code === 'auth/account-exists-with-different-credential') {
				this.facebookError = error;
				// I leave the following line, because I don't fully understand if it is only necessary for the function that I just replaced or it's part
				// of the following logic as well, either way it's not harmful to leave it here.
				this.$firebase.auth().tenantId = error.tenantId;
				this.providers = await this.getProviders(error.email, error.tenantId);
				this.isFacebook = true;
				this.loading = false;
				return;
			}
			console.log(error);
			this.loading = false;
			this.loadingText = this.$options.data.call(this).loadingText;
			this.$NOTIFICATION_HANDLER(error);
		}
	},
};
